import { Box, Grid2 as Grid, TextField, Typography } from '@mui/material';
import { VersionTooltip } from '@/components/VersionTooltip';
import type { FieldVersionHistory } from '@/hooks/useVersionHistory';
import { ACQUISITION_COST_FIELDS } from '../constants';
import { styles } from '../styles';
import type { DealDetailsFormField, DealDetailsFormValue, DealDetailsFormValues } from '../types';
import { getSectionMetadata } from '../utils/getSectionMetadata';
import { FormSection } from './FormSection';

type AcquisitionCostSectionProps = {
  values: DealDetailsFormValues;
  onChange: (field: DealDetailsFormField, value: DealDetailsFormValue) => void;
  errors?: Record<string, boolean>;
  versionHistory?: Map<string, FieldVersionHistory>;
};

export const AcquisitionCostSection = ({
  values,
  onChange,
  errors = {},
  versionHistory,
}: AcquisitionCostSectionProps) => {
  const metadata = getSectionMetadata(versionHistory, ACQUISITION_COST_FIELDS);

  return (
    <FormSection title='Acquisition Cost' metadata={metadata}>
      <Grid size={12} spacing={2} container>
        {ACQUISITION_COST_FIELDS.map(field => (
          <Grid size={{ sm: 12, md: 4 }} key={field.key}>
            <VersionTooltip fieldHistory={versionHistory?.get(field.key)} fieldType={field.type}>
              <Box>
                <Box sx={{ mb: 1 }}>
                  <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                    {field.label}
                  </Typography>
                </Box>
              </Box>
            </VersionTooltip>
            <TextField
              sx={styles.textField}
              name={field.key}
              value={values[field.key] || ''}
              onChange={event => onChange(field, event.target.value)}
              error={errors[field.key] || false}
              helperText={errors[field.key] ? 'Must be a number' : ''}
              fullWidth
              slotProps={{
                input: {
                  startAdornment: (
                    <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>US$</Box>
                  ),
                  endAdornment: (
                    <Box sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>{field.unit}</Box>
                  ),
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </FormSection>
  );
};
